import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import 'App/app.css';
import AuthClient from '@keethealth/auth-client';

const scope = (process.env.REACT_APP_OAUTH2_SCOPES || '').replace(/,/g, ' ');

AuthClient.init({
  url: process.env.REACT_APP_OAUTH2_ISSUER_URL,
  clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
  /* eslint-disable-next-line */
  storage: localStorage,
  scope,
  audience: [
    process.env.REACT_APP_OAUTH2_AUDIENCE,
  ],
});

ReactDOM.render(<App />, document.getElementById('root'));
